import { render, staticRenderFns } from "./Field.vue?vue&type=template&id=8b359a0e&scoped=true&"
import script from "./field.component?vue&type=script&lang=ts&"
export * from "./field.component?vue&type=script&lang=ts&"
import style0 from "./Field.vue?vue&type=style&index=0&id=8b359a0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b359a0e",
  null
  
)

export default component.exports